import { BRAND_NAME } from '../../config/brand';

export default {
  'customerDetails.menuTitle': 'Customer details',
  'customerDetails.title': 'Customer',
  'customerDetails.backTitle': 'Back to customers',
  'customerDetails.firstName': 'First name',
  'customerDetails.lastName': 'Last name',
  'customerDetails.nationalId': 'National ID',
  'customerDetails.email': 'Email',
  'customerDetails.contryCode': 'Country code',
  'customerDetails.phoneNumber': 'Phone number',
  'customerDetails.kycAttempts': 'KYC attempts:',
  'customerDetails.dateOfBirth': 'Date of birth',
  'customerDetails.kycDate': 'KYC success date',
  'customerDetails.idExpiry': 'ID expiry date',
  'customerDetails.resetButton': 'Reset',
  'customerDetails.saveButton': 'Save',
  'customerDetails.resetPopup.title': 'Are you sure?',
  'customerDetails.resetPopup.subTitle':
    `Performing this action will reset the KYC attempts count back to 0 and allow the customer to retry and complete their ${BRAND_NAME} order.`,
  'customerDetails.resetPopup.rejectButton': 'No',
  'customerDetails.resetPopup.successButton': 'Yes',
  'customerDetails.api.getInfoError': 'No data for this customer',
  'customerDetails.emailValidationError': 'Wrong email',
  'customerDetails.phoneValidationError': 'Wrong phone number',
  'customerDetails.errorToasterTitle': 'Operation failed',
  'customerDetails.error.400.003.024':
    `The new entered email belongs to another ${BRAND_NAME} user, please set a different one.`,
  'customerDetails.error.400.003.030':
    `The new entered number belongs to another ${BRAND_NAME} user, please set a different one.`,
};
